<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="e-ticket" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>EVENT SESSIONS</span>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div v-if="event_sessions && event_sessions.length > 0">
            <div class="voting-session-item" v-for="(item, index) in event_sessions" :key="index" :class="{
              active:
                selected_event_session &&
                selected_event_session.id == item.id,
            }">
              <div v-if="item.coverImage" @click="selectEventSession(item)"
                class="voting-session-item-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.coverImage
                  " />
              </div>
              <div @click="selectEventSession(item)" class="voting-session-item-top-panel">
                <div class="voting-session-item-image">
                  <img :src="$store.state.ASSETS_BASE_URL +
                    '/assets/uploaded/' +
                    item.logoImage
                    " />
                </div>
                <div class="voting-session-item-title">
                  <span>{{ item.title }}</span>
                </div>
              </div>
              <div class="voting-session-item-body-panel">
                <b-select v-if="item.seasonEnabled" placeholder="Select season" @input="onSeasonSelected($event, item)">
                  <option v-for="season in item.seasonCount" :value="season" :key="season">
                    Season {{ season }}
                  </option>
                </b-select>
                <b-select v-if="item.hasSubEvent == 1 && item.subEvents && item.subEvents.length > 0"
                  placeholder="Select sub event" @input="onSubEventSelected($event, item)">
                  <option v-for="subEvent in item.subEvents" :value="subEvent.id" :key="subEvent.id">
                    {{ getSubEventLabel(subEvent) }}
                  </option>
                </b-select>
              </div>
              <div class="voting-session-item-bottom-panel" @click="selectEventSession(item)">
                <div class="voting-session-item-bottom-left">
                  <div class="voting-session-item-startdate">
                    <b-icon icon="calendar"></b-icon>
                    <span>Start Date:
                      {{
                        moment(item.startTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                  <div class="voting-session-item-enddate">
                    <b-icon icon="calendar"></b-icon>
                    <span>End Date:
                      {{
                        moment(item.endTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                </div>
                <div class="voting-session-item-bottom-left">
                  <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                  <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                  <b-tag v-if="item.status == 'private'" type="is-warning">Private</b-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_report" class="rigth-panel active_session">
        <div class="rigth-panel-header">

          <div class="tabs-widget">
            <div class="tab-item" :class="{ active: streamTab == 'overview' }"
              @click="switchStreamTab('overview')">OVERVIEW</div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: streamTab == 'payed_transations' }"
              @click="switchStreamTab('payed_transations')">PAYED TRANSATIONS</div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: streamTab == 'free_tickets' }"
              @click="switchStreamTab('free_tickets')">
              INVITATION TICKETS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: streamTab == 'pre_sell' }" @click="switchStreamTab('pre_sell')">
              PRE-SELL TICKETS
            </div>
          </div>

        </div>


        <div class="rigth-panel-body" :class="{ expand: streamTab == 'overview' }"
          v-if="streamTab == 'overview' && reports">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">OVERVIEW</h2>
            <div class="rigth-panel-body-header-actions">
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="rigth-panel-top">
            <widgetCounter title="PAYED ONLINE AMOUNT" counterTextSize="20px" :value="$formatMoney(
              reports.earned_amount,
              (decimalCount = 0),
              (decimal = '.'),
              (thousands = ',')
            )

              ">
            </widgetCounter>


            <widgetCounter title="PAYED OFFLINE AMOUNT" counterTextSize="20px" :value="$formatMoney(
              reports.earned_presell_amount,
              (decimalCount = 0),
              (decimal = '.'),
              (thousands = ',')
            )

              ">
            </widgetCounter>



            <widgetCounter title="BROKERAGE FEE" counterTextSize="20px" :value="$formatMoney(
              reports.brokerageFee,
              (decimalCount = 0),
              (decimal = '.'),
              (thousands = ',')
            )
              ">
            </widgetCounter>
          </div>

          <BalancePaymentType
            :cardAmount="(reports.payed_by_card && reports.payed_by_card.total) || 0"
            :momoAmount="(reports.payed_by_momo && reports.payed_by_momo.total) || 0"
            :spennAmount="(reports.payed_by_spenn && reports.payed_by_spenn.total) || 0">
          </BalancePaymentType>
          </div>
        </div>


        <div class="rigth-panel-body" :class="{ expand: streamTab == 'payed_transations' }"
          v-if="streamTab == 'payed_transations' && reports">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              TRANSACTIONS HISTORY ({{ reports.total_payed }})
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-button v-if="reports.transactions.length > 0" type="is-default" outlined :loading="loading_download"
                @click="downloadTransationReport()">DOWNLOAD HISTORY</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="reports.transactions.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Identifier</th>
                  <th class="stick-th">Transaction ID</th>
                  <th class="stick-th">Payed With</th>
                  <th class="stick-th">Amount</th>
                  <th class="stick-th">Eaned</th>
                  <th class="stick-th">Status</th>
                  <th class="stick-th">Date</th>
                </tr>

                <template v-for="(item, index) in reports.transactions">
                  <tr v-if="!loading_transation_report" :key="index">
                    <td>
                      {{
                        item.bill_to_first_name
                          ? item.bill_to_first_name +
                          " " +
                          (item.bill_to_last_name == item.bill_to_first_name ? '' : item.bill_to_last_name)
                          : item.bill_to_phone
                      }}
                    </td>
                    <td>{{ item.transactionid }}</td>
                    <td>{{ item.payment_type }}</td>
                    <td>
                      {{
                        $formatMoney(
                          item.amount,
                          (decimalCount = 0),
                          (decimal = "."),
                          (thousands = ",")
                        )
                      }}
                    </td>

                    <td>
                      {{
                        $formatMoney(
                          item.earned + item.tax,
                          (decimalCount = 0),
                          (decimal = "."),
                          (thousands = ",")
                        )
                      }}
                    </td>

                    <td>
                      <b-tag class="tag-option" type="is-success">PAYED</b-tag>
                    </td>
                    <td>
                      {{
                        moment(item.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                  </tr>
                </template>

                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="reports.transactions.length == 0 && !loading_transation_report
            " title="No transactions found" subtitle="No transactions found for this report"></widgetNotfound>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: streamTab == 'free_tickets' }"
          v-if="streamTab == 'free_tickets'">
          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              INVITATION TICKETS ({{ invitationCount }})
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-button type="is-primary" outlined @click="showGenelateTicketModal('invitation')">GENERATE
                INVITATION</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="invitationBatches.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Seat Type</th>
                  <th class="stick-th">Total Tickets</th>
                  <th class="stick-th">Tickets Status</th>
                  <th class="stick-th">Report Status</th>
                  <th class="stick-th">Date</th>
                  <th class="stick-th">Action</th>
                </tr>
                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
                <template v-for="(batch, index) in invitationBatches">
                  <tr v-if="!loading_transation_report" :key="batch.id" class="batch-row">
                    <td>
                      <div @click="toggleBatchExpansion(batch.id)" class="transation-content">
                        <div class="batch-header">
                          <b-icon :icon="expandedBatches[batch.id] ? 'chevron-down' : 'chevron-right'"
                            class="expand-icon"></b-icon>
                          <h3>{{ batch.seatType }} ({{ batch.type == 'subevents' ? getSubEventLabel(batch) : `Whole Event` }})</h3>
                        </div>
                      </div>
                    </td>
                    <td>{{ batch.totalTickets }}</td>
                    <td>
                      <b-tag v-if="batch.activated" type="is-success">
                        INITIAL ALL ACTIVATED
                      </b-tag>
                      <span v-else>
                        {{ batch.activatedTickets.length }} / {{ batch.totalTickets }} Activated
                      </span>
                    </td>
                    <td>
                      {{ batch.usedTickets.length }} / {{ batch.totalTickets }} Used
                    </td>
                    <td>
                      {{
                        moment(batch.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                    <td>
                      <b-dropdown aria-role="list" class="is-pulled-left" position="is-bottom-left">
                        <template #trigger>
                          <b-icon icon="dots-vertical"></b-icon>
                        </template>
                        <b-dropdown-item @click="downloadInvitationBatch(batch)" aria-role="listitem">
                          Download All Tickets
                        </b-dropdown-item>
                        <b-dropdown-item v-if="!batch.activated" @click="toggleInvitationBatchStatus(batch, 'activate')"
                          aria-role="listitem">
                          Activate All Tickets
                        </b-dropdown-item>
                        <b-dropdown-item v-else @click="toggleInvitationBatchStatus(batch, 'deactivate')"
                          aria-role="listitem">
                          Deactivate All Tickets
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteInvitationBatch(batch)" aria-role="listitem" type="is-danger">
                          Delete All Tickets
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                  <!-- Expanded individual tickets -->
                  <template v-if="expandedBatches[batch.id]">
                    <tr v-for="(ticket, ticketIndex) in batch.tickets" :key="'ticket-' + ticket.ticketToken"
                      class="individual-ticket-row">
                      <td>
                        <div class="transation-content ticket-indent">
                          <h4>{{ ticket.ticketToken }}</h4>
                        </div>
                      </td>
                      <td colspan="2"></td>
                      <td>
                        <b-tag v-if="ticket.aproved" type="is-success">
                          USED
                        </b-tag>
                        <b-tag v-else type="is-warning">
                          NOT USED
                        </b-tag>
                      </td>
                      <td>

                      </td>
                      <td>
                        <b-dropdown aria-role="list" class="is-pulled-left" position="is-bottom-left">
                          <template #trigger>
                            <b-icon icon="dots-vertical"></b-icon>
                          </template>
                          <b-dropdown-item @click="downloadEnvitation(batch, ticket)" aria-role="listitem">
                            Download
                          </b-dropdown-item>
                          <b-dropdown-item v-clipboard:copy="makeEnvitation(ticket.ticketToken)"
                            v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">
                            Copy Invitation
                          </b-dropdown-item>
                          <b-dropdown-item v-if="!ticket.aproved" @click="deleteInvitationTicket(ticket)"
                            aria-role="listitem" type="is-danger">
                            Delete
                          </b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                  </template>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="invitationBatches.length == 0 && !loading_transation_report
            " title="No Invitation tickets found" subtitle="No invitation tickets found for this event">
            </widgetNotfound>
          </div>
        </div>

        <div class="rigth-panel-body" :class="{ expand: streamTab == 'pre_sell' }" v-if="streamTab == 'pre_sell'">
          <b-loading :is-full-page="false" v-model="isDownloading" :can-cancel="true"></b-loading>

          <div class="rigth-panel-body-header">
            <h2 class="rigth-panel-body-header-title">
              PRE SELL TICKETS
            </h2>
            <div class="rigth-panel-body-header-actions">
              <b-button type="is-primary" outlined @click="showGenelateTicketModal('pre_sell')">GENERATE
                TICKETS</b-button>
              <span @click="resetSession()">Close</span>
            </div>
          </div>
          <div class="rigth-panel-body-body">
            <div class="table-widget" v-if="presell.length > 0">
              <table>
                <tr>
                  <th class="stick-th">Ticket Type</th>
                  <th class="stick-th">Total Tickets</th>
                  <th class="stick-th">Tickets Status</th>
                  <th class="stick-th">Report Status</th>
                  <th class="stick-th">Date</th>
                  <th class="stick-th">Action</th>
                </tr>
                <template v-for="(item, index) in 15">
                  <tr v-if="loading_transation_report" :key="index">
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                    <td><b-skeleton width="90%"></b-skeleton></td>
                  </tr>
                </template>
                <template v-for="(item, index) in presell">
                  <tr v-if="!loading_transation_report" :key="index">
                    <td>
                      <div class="transation-content">
                        <h3>
                          {{ item.seatType }} ({{ item.type == 'subevents' ? getSubEventLabel(item) : `Whole Event` }})
                        </h3>
                      </div>

                    </td>

                    <td>
                      {{ item.totalTickets }}
                    </td>

                    <td>
                      <b-tag v-if="item.activated" type="is-success">
                        INITIAL ALL ACTIVATED
                      </b-tag>
                      <span v-else>
                        {{ item.activatedTickets.length }}/ {{ item.totalTickets }} Activated
                      </span>
                    </td>
                    <td>
                      {{ item.usedTickets.length }} /{{ item.totalTickets }} Used
                    </td>

                    <td>
                      {{
                        moment(item.created_at).format("MMM DD YYYY, h:mm A")
                      }}
                    </td>
                    <td>

                      <b-dropdown aria-role="list" class="is-pulled-left" position="is-bottom-left">
                        <template #trigger>
                          <b-icon icon="dots-vertical"></b-icon>
                        </template>
                        <b-dropdown-item v-if="!item.activated" @click="toggleTicketStatus(item, 'activate')"
                          aria-role="listitem">Activate
                          Tickets</b-dropdown-item>

                        <b-dropdown-item v-else @click="toggleTicketStatus(item, 'deactivate')"
                          aria-role="listitem">Deactivate
                          Tickets</b-dropdown-item>

                        <b-dropdown-item @click="downloadTickets(item)" aria-role="listitem">
                          Download</b-dropdown-item>

                        <b-dropdown-item @click="deletePreSellTicket(item)" aria-role="listitem">
                          Delete</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </template>
              </table>
            </div>

            <widgetNotfound v-if="reports.transactions.length == 0 && !loading_transation_report
            " title="No Free ticket found" subtitle="No free ticket found for this report"></widgetNotfound>
          </div>
        </div>

      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound title="No report" subtitle="Please select a event session to view report"></widgetNotfound>
      </div>
    </div>
    <!-- Genelate event modal -->
    <GenelateEventTicketModal v-if="showGenelateEventTicketModal" :event="selected_report" :type="genelateTicketType"
      @saved="onGenerateTicketSuccess" @close="showGenelateEventTicketModal = false"></GenelateEventTicketModal>

  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
import BalancePaymentType from "./components/BalancePaymentType.vue";
import GenelateEventTicketModal from "./modals/genelateEventTicketModal.vue";
import { SOCKET_SERVER_SOCKET_BASE_URL } from "@/store/variables.js"
import { getSubEventLabel } from "@/helpers/subEvent.js"
export default {
  components: {
    TabsWidget,
    BalancePaymentType,
    GenelateEventTicketModal
  },
  sockets: {},
  data: () => ({
    loading_event_session: false,
    loading_transation_report: false,
    event_sessions: [],
    selected_report: null,
    reports: {
      tax_balance: 0,
      earned_amount: 0,
      earned_presell_amount: 0,
      total_payed: 0,
      payed_by_card: {
        total: 0,
      },
      payed_by_momo: {
        total: 0,
      },
      payed_by_spenn: {
        total: 0,
      },
      transactions: [],
      freeTickets: []
    },
    loading_download: false,
    selected_event_session: null,
    streamTab: 'overview',
    showGenelateEventTicketModal: false,
    genelateTicketType: null,
    presell: [],
    invitationBatches: [],
    isDownloading: false,
    selected_season: 0,
    selected_sub_event: 0,
    expandedBatches: {},
  }),
  mounted() {
    let vm = this;
    vm.getMyEventSessions();
    // Listen to eventBus events for ticket selection
    vm.$store.state.eventBus.$on('ticket-selection-changed', () => {
      vm.$nextTick(() => {
        vm.$forceUpdate();
      });
    });
  },
  watch: {
    'reports.freeTickets': {
      handler() {
        // Ensure isChecked is initialized for new data
        this.initializeTicketSelections();
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true
    }
  },
  computed: {
    isAllSelected() {
      const availableTickets = this.reports.freeTickets.filter(ticket => !ticket.aproved);
      const checkedTickets = this.reports.freeTickets.filter(ticket => ticket.isChecked);
      return checkedTickets.length === availableTickets.length && availableTickets.length > 0;
    },
    isIndeterminate() {
      const availableTickets = this.reports.freeTickets.filter(ticket => !ticket.aproved);
      const checkedTickets = this.reports.freeTickets.filter(ticket => ticket.isChecked);
      return checkedTickets.length > 0 && checkedTickets.length < availableTickets.length;
    },
    selectedTicketsCount() {
      return this.reports.freeTickets.filter(ticket => ticket.isChecked).length;
    },
    selectedTicketsIds() {
      return this.reports.freeTickets.filter(ticket => ticket.isChecked).map(ticket => ticket.id);
    },
    invitationCount() {
      return this.invitationBatches.reduce((acc, batch) => acc + batch.totalTickets, 0);
    }
  },
  methods: {
    getSubEventLabel,
    toggleTicketStatus(item, status) {
      let vm = this;
      vm.$store
        .dispatch("EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS", {
          id: item.id,
          status: status == 'activate' ? true : false,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Ticket status updated successfully",
          });
          vm.getPreSellSession(vm.selected_season, vm.selected_sub_event);
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "error",
            title: "Message",
            text: "Failed to update ticket status",
          });
        });
    },
    downloadTickets(item) {
      let vm = this;
      vm.isDownloading = true;
      if (!item.templateImage) {
        vm.$notify({
          group: "status",
          type: "error",
          title: "Message",
          text: "No ticket template found",
        });
        return;
      }
      const payload = {
        templateLink: vm.$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + item.templateImage,
        tickets: item.tickets.map((ticket) => ticket.ticketToken),
        seatType: item.seatType,
        eventTitle: vm.selected_report.title,
      };
      vm.$store
        .dispatch("EVENTS_DOWNLOAD_PRE_SELL_TICKET", payload)
        .then((response) => {
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Tickets downloaded successfully",
          });
          // Save pdf file from response
          const link = document.createElement("a");
          link.href = SOCKET_SERVER_SOCKET_BASE_URL + "tickets/" + response.data.file;
          link.setAttribute(
            "download",
            payload.seatType + "_" + payload.eventTitle + "_" + item.totalTickets + "_tickets.pdf"
          );
          // set target to blank
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
        })
        .catch(({ response }) => {
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Message",
            text: "Failed to download tickets",
          });
        });
    },
    downloadEnvitation(batch, item) {
      let vm = this;
      vm.isDownloading = true;
      if (!batch.templateImage) {
        vm.$notify({
          group: "status",
          type: "error",
          title: "Message",
          text: "No invitation template found",
        });
        return;
      }
      const payload = {
        templateLink: vm.$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + batch.templateImage,
        ticketToken: item.ticketToken,
      };
      vm.$store
        .dispatch("EVENTS_DOWNLOAD_INVITATION_TICKET", payload)
        .then((response) => {
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Ticket downloaded successfully",
          });
          // Save pdf file from response
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', item.ticketToken + '_ticket.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
        .catch((error) => {
          console.log(error);
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Message",
            text: "Failed to download tickets",
          });
        });

    },
    deletePreSellTicket(item) {
      let vm = this;
      this.$buefy.dialog.confirm({
        title: "Message",
        message: "Are you sure you want to delete this generated tickets?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_PRE_SELL_TICKET", {
              id: item.id,
            })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: "Ticket deleted successfully",
              });
              vm.getPreSellSession(vm.selected_season, vm.selected_sub_event);
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "Message",
                text: "Failed to delete ticket",
              });
            });
        },
      });
    },
    makeEnvitation(ticketToken) {
      let vm = this;
      let ticket_qr_code_url = vm.$store.state.SITE_BASE_URL + 'tk?q=' + ticketToken;
      let envitation_message = "Welcome to our event " + vm.selected_report.title + ".This is your envitation ticket, You will be asked to show token or QR code from the link:\n Token:" + ticketToken + "\nLink:" + ticket_qr_code_url;
      return envitation_message;
    },
    switchStreamTab(tab) {
      let vm = this;
      if (tab == 'pre_sell') {
        vm.getPreSellSession(vm.selected_season, vm.selected_sub_event);
      } else if (tab == 'free_tickets') {
        vm.getInvitationBatches(vm.selected_season, vm.selected_sub_event);
      }
      vm.streamTab = tab;
    },
    getReportFilterParams(selectedSeason = 0, selectedSubEvent = 0) {
      const session = this.selected_event_session;
      return {
        seasonEnabled: selectedSeason > 0 && session ? session.seasonEnabled : false,
        selectedSeason: selectedSeason,
        subEventEnabled: selectedSubEvent > 0 && session ? session.hasSubEvent == 1 : false,
        selectedSubEvent: selectedSubEvent,
      };
    },
    refreshEventReport(item, selectedSeason = 0, selectedSubEvent = 0) {
      let vm = this;
      vm.loading_transation_report = true;
      vm.selected_report = item;
      vm.selected_event_session = item;
      vm.getPreSellSession(selectedSeason, selectedSubEvent);
      if (vm.streamTab === 'free_tickets') {
        vm.getInvitationBatches(selectedSeason, selectedSubEvent);
      }
      vm.$store
        .dispatch("ADMIN_USER_TRANSATION_REPORT", {
          id: item.id,
          type: "events",
          ...vm.getReportFilterParams(selectedSeason, selectedSubEvent),
        })
        .then((response) => {
          vm.loading_transation_report = false;
          vm.reports = response.data.return;
          vm.initializeTicketSelections();
        })
        .catch(({ response }) => {
          vm.loading_transation_report = false;
        });
    },
    toggleBatchExpansion(batchId) {
      this.$set(this.expandedBatches, batchId, !this.expandedBatches[batchId]);
    },
    downloadInvitationBatch(batch) {
      let vm = this;
      vm.isDownloading = true;
      if (!batch.templateImage) {
        vm.$notify({
          group: "status",
          type: "error",
          title: "Message",
          text: "No ticket template found",
        });
        return;
      }
      const payload = {
        templateLink: vm.$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + batch.templateImage,
        tickets: batch.tickets.map((ticket) => ticket.ticketToken),
        seatType: batch.seatType,
        eventTitle: vm.selected_report.title,
      };
      vm.$store
        .dispatch("EVENTS_DOWNLOAD_INVITATION_BATCH", payload)
        .then((response) => {
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Tickets downloaded successfully",
          });

          const link = document.createElement("a");
          link.href = SOCKET_SERVER_SOCKET_BASE_URL + "tickets/" + response.data.file;
          link.setAttribute(
            "download",
            payload.seatType + "_" + payload.eventTitle + "_" + batch.totalTickets + "_invitation_tickets.zip"
          );
          // set target to blank
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();

        })
        .catch(({ response }) => {
          vm.isDownloading = false;
          vm.$notify({
            group: "status",
            type: "error",
            title: "Message",
            text: "Failed to download tickets",
          });
        });
    },
    toggleInvitationBatchStatus(batch, status) {
      let vm = this;
      vm.$store
        .dispatch("EVENTS_TOGGLE_INVITATION_BATCH_STATUS", {
          id: batch.id,
          status: status == 'activate' ? true : false,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Batch status updated successfully",
          });
          vm.getInvitationBatches(vm.selected_season, vm.selected_sub_event);
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "error",
            title: "Message",
            text: "Failed to update batch status",
          });
        });
    },
    deleteInvitationBatch(batch) {
      let vm = this;
      this.$buefy.dialog.confirm({
        title: "Delete Invitation Batch",
        message: `Are you sure you want to delete all ${batch.totalTickets} tickets for ${batch.seatType}? This action cannot be undone.`,
        confirmText: "Delete All",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_INVITATION_BATCH", {
              id: batch.id,
            })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: "Invitation batch deleted successfully",
              });
              vm.getInvitationBatches(vm.selected_season, vm.selected_sub_event);
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "Message",
                text: "Failed to delete invitation batch",
              });
            });
        },
      });
    },
    downloadTransationReport() {
      let vm = this;
      vm.loading_download = true;
      vm.$store
        .dispatch("ADMIN_USER_DOWNLOAD_TRANSATION_REPORT", {
          stream_id: vm.selected_report.id,
          type: "events",
          ...vm.getReportFilterParams(vm.selected_season, vm.selected_sub_event),
        })
        .then((response) => {
          vm.loading_download = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: "Report downloaded successfully",
          });
          // Save cvs file from response
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "text/csv",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            vm.selected_report.title + " transactions history report.csv"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.loading_download = false;
          console.log(error);
        });
    },
    selectEventSession(item) {
      let vm = this;
      vm.selected_season = 0;
      vm.selected_sub_event = 0;
      vm.refreshEventReport(item, 0, 0);
    },
    onSeasonSelected(value, item) {
      let vm = this;
      vm.selected_season = value;
      vm.refreshEventReport(item, value, vm.selected_sub_event);
    },
    onSubEventSelected(value, item) {
      let vm = this;
      vm.selected_sub_event = value;
      vm.refreshEventReport(item, vm.selected_season, value);
    },
    getPreSellSession(selectedSeason = 0, selectedSubEvent = 0) {
      let vm = this;
      if (!vm.selected_event_session) return;
      vm.$store
        .dispatch("EVENTS_GET_ALL_PRE_SELL_TICKETS", {
          id: vm.selected_event_session.id,
          ...vm.getReportFilterParams(selectedSeason, selectedSubEvent),
        })
        .then((response) => {
          vm.presell = response.data.return;
        })
        .catch(({ response }) => {
        });
    },
    getInvitationBatches(selectedSeason = 0, selectedSubEvent = 0) {
      let vm = this;
      if (!vm.selected_event_session) return;
      vm.$store
        .dispatch("EVENTS_GET_ALL_INVITATION_TICKETS", {
          id: vm.selected_event_session.id,
          ...vm.getReportFilterParams(selectedSeason, selectedSubEvent),
        })
        .then((response) => {
          vm.invitationBatches = response.data.return;
        })
        .catch(({ response }) => {
        });
    },
    showGenelateTicketModal(type) {
      let vm = this;
      vm.genelateTicketType = type;
      vm.showGenelateEventTicketModal = true;
    },
    onGenerateTicketSuccess() {
      let vm = this;
      vm.showGenelateEventTicketModal = false;
      vm.refreshEventReport(vm.selected_event_session, vm.selected_season, vm.selected_sub_event);
    },
    getMyEventSessions() {
      let vm = this;
      vm.loading_event_session = true;
      vm.$store
        .dispatch("EVENTS_GET_ALL_EVENT")
        .then((response) => {
          vm.loading_event_session = false;
          vm.event_sessions = response.data;
        })
        .catch(({ response }) => {
          vm.loading_event_session = false;
        });
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Copy successfully!",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    initializeTicketSelections() {
      // Add isChecked property to each ticket using Vue.set for reactivity
      this.reports.freeTickets.forEach(ticket => {
        if (ticket.isChecked === undefined) {
          this.$set(ticket, 'isChecked', false);
        }
      });
    },
    onTicketSelectionChange(ticket) {
      console.log('Individual checkbox changed for ticket:', ticket.id, 'isChecked:', ticket.isChecked);
      // Force reactivity update for computed properties
      this.$nextTick(() => {
        this.$forceUpdate();
        // Emit event to notify other components of selection change
        this.$store.state.eventBus.$emit('ticket-selection-changed');
      });
    },
    toggleSelectAll() {
      let vm = this;
      const availableTickets = vm.reports.freeTickets.filter(ticket => !ticket.aproved);
      console.log('toggleSelectAll called. isAllSelected:', vm.isAllSelected, 'availableTickets:', availableTickets.length);

      if (vm.isAllSelected) {
        // Unselect all tickets
        console.log('Unselecting all tickets');
        availableTickets.forEach(ticket => {
          vm.$set(ticket, 'isChecked', false);
        });
      } else {
        // Select all non-approved tickets
        console.log('Selecting all available tickets');
        availableTickets.forEach(ticket => {
          vm.$set(ticket, 'isChecked', true);
        });
      }

      // Force reactivity update
      this.$nextTick(() => {
        vm.$forceUpdate();
        // Emit event to notify of selection change
        vm.$store.state.eventBus.$emit('ticket-selection-changed');
      });
    },
    deleteInvitationTicket(item) {
      let vm = this;
      this.$buefy.dialog.confirm({
        title: "Delete Invitation Ticket",
        message: `Are you sure you want to delete the ticket "${item.ticketToken}"? This action cannot be undone.`,
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_INVITATION_TICKET", {
              id: item.id,
            })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: "Invitation ticket deleted successfully",
              });
              vm.refreshEventReport(vm.selected_event_session, vm.selected_season, vm.selected_sub_event);
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "Message",
                text: "Failed to delete invitation ticket",
              });
            });
        },
      });
    },
    deleteSelectedTickets() {
      let vm = this;
      this.$buefy.dialog.confirm({
        title: "Delete Multiple Tickets",
        message: `Are you sure you want to delete ${vm.selectedTicketsCount} selected ticket(s)? This action cannot be undone.`,
        confirmText: "Delete All",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS", {
              ids: vm.selectedTicketsIds,
            })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: `${vm.selectedTicketsCount} invitation ticket(s) deleted successfully`,
              });
              vm.clearAllSelections();
              vm.refreshEventReport(vm.selected_event_session, vm.selected_season, vm.selected_sub_event);
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "Message",
                text: "Failed to delete invitation tickets",
              });
            });
        },
      });
    },
    clearAllSelections() {
      // Clear all ticket selections
      this.reports.freeTickets.forEach(ticket => {
        this.$set(ticket, 'isChecked', false);
      });
      // Force reactivity update
      this.$nextTick(() => {
        this.$forceUpdate();
        this.$store.state.eventBus.$emit('ticket-selection-changed');
      });
    },
    resetSession() {
      let vm = this;
      vm.selected_report = null;
      vm.streamTab = 'overview';
      vm.clearAllSelections();
      vm.expandedBatches = {};
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
  beforeDestroy() {
    // Clean up eventBus listener
    this.$store.state.eventBus.$off('ticket-selection-changed');
  }
};
</script>
<style lang="scss" scoped>
@import "./styles/mobile-panel.scss";

.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;
    justify-content: center;
    align-items: center;
    @include dashboard-wrapper-body-mobile;
    @include dashboard-flex-layout-mobile;

    .left-panel {
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .voting-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
          }

          .voting-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .voting-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .voting-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .voting-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .voting-session-item-body-panel {
            padding: 0px 10px;
          }

          .voting-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .voting-session-item-startdate,
              .voting-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .voting-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 400px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      overflow-y: auto;
      @include dashboard-right-panel-mobile;

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 20px;
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #ddd;
        justify-content: space-between;
        position: sticky;
        top: 0;
        background: white;

        .tabs-widget {
          display: flex;
          align-items: flex-end;

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 14px 4px;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }
      }

      .rigth-panel-top {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;
        padding: 10px;

        @media (max-width: 1306px) {
          grid-template-columns: repeat(2, 1fr);
        }

        @media (max-width: 860px) {
          grid-template-columns: 100%;
        }
      }

      .rigth-panel-body {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;

        &.expand {
          flex: 1;
        }

        .rigth-panel-body-body {
          flex: 1;
          min-height: 0;
          overflow-y: auto;

          .bulk-actions {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
          }

          .table-widget {
            table {
              width: 100%;

              tr {
                th {
                  white-space: nowrap;
                }

                td {
                  white-space: nowrap;

                  .tag-lists {
                    display: flex;
                    width: fit-content;
                    flex-shrink: 0;
                    min-width: 170px;
                  }
                }
              }
            }
          }

          .stick-th {
            position: sticky;
            top: 0px;
            background: #fff;
            z-index: 1;
            border-bottom: 1px solid #ddd;
          }

          .batch-row {
            cursor: pointer;
            background: #f8f9fa;

            &:hover {
              background: #e9ecef;
            }

            .batch-header {
              display: flex;
              align-items: center;
              gap: 10px;

              .expand-icon {
                color: var(--wecodefy-secondary-color, #9fc953);
              }

              h3 {
                margin: 0;
                font-size: 16px;
                font-weight: 600;
              }
            }
          }

          .individual-ticket-row {
            background: #fff;

            .ticket-indent {
              padding-left: 30px;

              h4 {
                margin: 0;
                font-size: 14px;
                font-weight: 500;
                color: #666;
              }
            }
          }
        }
      }

    }
  }
}
</style>